import { Box } from '@material-ui/core';
import React from 'react';

type Props = React.HTMLAttributes<HTMLFormElement> & {
    actions?: JSX.Element;
};

const SGSFormLayout: React.FC<Props> = ({ children, actions, ...props }) => {
    return (
        <form {...props} className="w-100 d-flex flex-column justify-content-center align-items-center">
            <Box width="100%" mt={4}>
                {children}
            </Box>
            <Box width="100%">{actions}</Box>
        </form>
    );
};

export default SGSFormLayout;

export { default as SGSForm } from './SGSForm';
